export default "__VITE_ASSET__DppmxQNZ__"